import { getPeriodOptionFromPeriodValue } from '@/enums/period-options';
import { getRangeObjFromRangeTitle } from '@/enums/range-options';
import { CHART_TYPE_OPTION_PERF_CHART } from '@/enums/chart-type-options';

type RelevantSharpCharts2ChartImageUrlData = Pick<SharpCharts2ChartImageUrlData, 'period' | 'range' | 'chartType' | 'rangeBar' | 'rangeGap' | 'rangeYears' | 'rangeMonths' | 'rangeDays' | 'rangeStartDate' | 'rangeEndDate' | 'perfChartSymbolsString' | 'useMainChartSymbolAsBaseline' | 'i'>;

export function getStyleUrlSearchParams(sharpCharts2ChartImageUrlData: RelevantSharpCharts2ChartImageUrlData, existingUrlSearchParams?: URLSearchParams): URLSearchParams {
  const {
    period,
    range,
    chartType,
    rangeBar,
    rangeGap,
    rangeYears,
    rangeMonths,
    rangeDays,
    rangeStartDate,
    rangeEndDate,
    perfChartSymbolsString,
    useMainChartSymbolAsBaseline,
    i
  } = sharpCharts2ChartImageUrlData;

  const periodOption = getPeriodOptionFromPeriodValue(period);
  const rangeOption = getRangeObjFromRangeTitle(range);
  const urlSearchParams = existingUrlSearchParams ?? new URLSearchParams();

  urlSearchParams.set('p', periodOption.sharpCharts2Id);

  if (rangeOption.useBarAndGap) {
    urlSearchParams.set('b', rangeBar);
    urlSearchParams.set('g', rangeGap);
  } else if (rangeOption.useNumberOfDays) {
    urlSearchParams.set('yr', rangeYears);
    urlSearchParams.set('mn', rangeMonths);
    urlSearchParams.set('dy', rangeDays);
  } else if (rangeOption.useStartDateAndEndDate) {
    if (rangeStartDate) {
      urlSearchParams.set('st', rangeStartDate);
    }

    if (rangeEndDate) {
      urlSearchParams.set('en', rangeEndDate);
    }
  }

  if (chartType === CHART_TYPE_OPTION_PERF_CHART.value) {
    urlSearchParams.set('compare', perfChartSymbolsString);

    if (useMainChartSymbolAsBaseline) {
      urlSearchParams.set('perf', 'true');
    }
  }

  urlSearchParams.set('id', i);

  return urlSearchParams;
}
